import { Col, Divider, Row, Switch, Text } from 'components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const Item = ({ text, bold, value, setValue = () => null, noBottom }) => {
  return (
    <Col wid="100%">
      <Row between marg={`19px 0 ${noBottom ? 10 : 18}px`} wid="100%">
        <Text b1 bold={bold}>
          {text}
        </Text>

        <Switch activated={value} onClick={() => setValue(!value)} />
      </Row>

      {!noBottom && <Divider />}
    </Col>
  );
};

const EmailNotifications = (props) => {
  const [showNotifs, setShowNotifs] = useState(false),
    { t } = useTranslation();

  return (
    <Col wid="100%" marg="24px 0 0">
      <Item
        text={t('settings.enableEmailNotifications')}
        value={showNotifs}
        setValue={setShowNotifs}
        bold
      />

      {showNotifs && (
        <Col wid="100%">
          <Item text={t('settings.newComments')} />

          <Item text={t('settings.newTags')} />

          <Item text={t('settings.newSubscriptions')} />

          <Item text={t('settings.newFriends')} />

          <Item text={t('settings.friendRequests')} />

          <Item text={t('settings.notificationForLikes')} />

          <Item text={t('settings.newMessages')} />

          <Item text={t('settings.photosNotifications')} noBottom />
        </Col>
      )}
    </Col>
  );
};

export default EmailNotifications;
